import styles from "./NewYearCard.module.css";

import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import EditScreenItemHeaderDiv from "../../Reusables/EditScreenItemHeaderDiv";
import EditScreenHeaderInfoDiv from "../../Reusables/EditScreenHeaderInfoDiv";

import sample_1_1 from "../../../assets/images/edit_screen/NewYearCard/sample_1_1.png";
import sample_1_2 from "../../../assets/images/edit_screen/NewYearCard/sample_1_2.png";
import sample_2_1 from "../../../assets/images/edit_screen/NewYearCard/sample_2_1.png";
import sample_2_2 from "../../../assets/images/edit_screen/NewYearCard/sample_2_2.png";
import sample_3_1 from "../../../assets/images/edit_screen/NewYearCard/sample_3_1.png";
import sample_3_2 from "../../../assets/images/edit_screen/NewYearCard/sample_3_2.png";
import sample_4_1 from "../../../assets/images/edit_screen/NewYearCard/sample_4_1.png";
import sample_4_2 from "../../../assets/images/edit_screen/NewYearCard/sample_4_2.png";

import NewYearCardReusable from "./NewYearCard_Reusable";

import PhotoSelection from "../PhotoSelection/PhotoSelection";
import { useState, useEffect, useRef, createRef } from "react";
import save_icon from "../../../assets/images/icons/save_icon.png";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../Hooks/useAxios";

const NewYearCard = () => {
  const MAX_ITEMS = 50;
  const { product_id } = useParams();
  const childRefs = useRef(
    Array(MAX_ITEMS)
      .fill(null)
      .map(() => createRef())
  );

  const allImagesPicked = (images, radionMainType) => {
    const neededNumberOfImages = radionMainType.includes(3) ? 3 : 1;
    return (
      images.reduce((total, item) => total + item.count, 0) ===
      neededNumberOfImages
    );
  };
  //SO here callback will not change the parent state
  //callback will save the states for future use and copy mechanisms

  //Default PhotoArray
  let defaultPhotoArray = Array.from({ length: 3 }, () => ({
    src: "",
    count: 0,
    selected: false,
    copied: false,
  }));

  let defaultStateSingleProduct = {
    images: defaultPhotoArray,
    name: "",
    firstName: "",
    postcode: "",
    address: "",
    wording: "",
    customWording: "",
    otherRequests: "",
    radioMainType: "パターンA1枚",
    copied: false,
  };

  const [copyDetails, setCopyDetails] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [item, setItem] = useState({});
  const axios = useAxios();
  const navigate = useNavigate();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  console.log("PRODUCT CODE IS: ");
  console.log(product_id);

  const [showSelectionPopup, setShowSelectionPopup] = useState(false);

  const [imagesLeft, setImagesLeft] = useState(0);
  const [currentImageSelectionIndex, setCurrentPhotoSelectionIndex] =
    useState(-1);
  const [psk, setpsk] = useState(0);
  const [selectedImageSlot, setSelectedImageSlot] = useState(-1);
  let [editState, setEditState] = useState([]);
  let [psx, setPsx] = useState(-1);
  const imageSelectionPopup = (index, count, selectedSlot = -1) => {
    setShowSelectionPopup(true);
    setImagesLeft(count);
    setCurrentPhotoSelectionIndex(index);
    setpsk(psk + 1);
    setSelectedImageSlot(selectedSlot);
    console.log("EDITSTATE BEFORE");
    console.log(editState);
  };
  const onPhotoSelectionEnd = (photo_url) => {
    setShowSelectionPopup(false);
    console.log("Photo Selection ends");
    console.log(photo_url.length);
    console.log(photo_url);
    const temp = JSON.parse(JSON.stringify(editState));
    console.log("States Before");
    console.log(temp);
    let picIdx = 0;

    for (let i = 0; i < 3; i++) {
      if (temp[currentImageSelectionIndex].images[i].count === 0) {
        temp[currentImageSelectionIndex].images[i].src = photo_url[picIdx++];
        temp[currentImageSelectionIndex].images[i].count = 1;
        if (photo_url.length === 1) break;
      }
    }

    console.log("States After");
    console.log(temp);
    setEditState(temp);
  };

  const changeEditState = (index, state) => {
    const temp = Array.from(editState);
    temp[index] = state;
    setEditState(temp);
  };
  const changePreviewImage = (index, newImage) => {
    console.log("chaning preview image");
    const temp = Array.from(previewImages);
    temp[index] = newImage;
    setPreviewImages(temp);
  };
  const checkAllUploaded = (list) => {
    for (let i = 0; i < list.length; i++) {
      const images = list[i].images;
      const radionMainType = list[i].radioMainType;
      if (!allImagesPicked(images, radionMainType)) {
        setPsx(i);
        return false;
      }
    }
    return true;
  };

  const largeImgSelectedForPatternA3B3 = (list) => {
    for (let i = 0; i < list.length; i++) {
      const images = list[i].images;
      const radionMainType = list[i].radioMainType;
      if (radionMainType.includes(3)) {
        const largeImgSelected = images.some((item) => item.selected);
        return largeImgSelected;
      }
      return true;
    }
  };

  const confirmEdits = async () => {
    console.log("Confirm Edits. Send to server");
    console.log(editState);
    console.log(previewImages);
    if (!checkAllUploaded(editState)) {
      setShowModal(true);
      return false;
    }

    if (!largeImgSelectedForPatternA3B3(editState)) {
      alert("大きく表示される画像を選択する必要があります");
      return;
    }

    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }

    console.log(tempDetails, "new years card tempdetails");

    const data = new FormData();
    data.append("design_details", JSON.stringify(tempDetails));
    data.append("copy_details", JSON.stringify(copyDetails));
    data.append("order_item_id", product_id);
    data.append("action", "CONFIRM");

    axios
      .post(backend_base + "/design/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Posted THE EDIT DATA");
          console.log(res.data);
          // navigate("/design-box");
          navigate("/design-box/complete-submission", { state: { title : "年賀状20", subtitle : "枚", count : count, address : "", item : item } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const saveToServer = () => {
    console.log("Send This to server");
    console.log(editState);
    const tempDetails = [];
    for (let i = 0; i < editState.length; i++) {
      tempDetails.push(editState[i]);
    }

    let save_data = {
      design_details: JSON.stringify(tempDetails),
      order_item_id: product_id,
      preview_images: [],
      action: "SAVE",
      copy_details: JSON.stringify(copyDetails),
    };

    axios
      .post(backend_base + "/design/edit", save_data)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("SAVED THE EDIT DATA");
          console.log(res.data);
          setSaveSuccess(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const [count, setCount] = useState(0);

  useEffect(() => {
    axios
      .get(backend_base + "/order/item/details/" + product_id)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Product With ID");
          console.log(res.data);
          setItem(res.data);
          setCount(res.data.quantity);
          let design = res.data.design;
          let status = design.design_status;
          console.log(design);
          console.log(design.design_status);
          if (status === "SAVED") {
            console.log(JSON.parse(design.design_details));
            setEditState(JSON.parse(design.design_details));
            setCopyDetails(JSON.parse(design.copy_details));
            let tempPreviewImages = [];
            for (let i = 0; i < res.data.quantity; i++) {
              tempPreviewImages.push(0);
            }
            setPreviewImages(tempPreviewImages);
          } else {
            let tempState = [];
            let tempPreviewImages = [];
            let tempCopyDetails = [];
            for (let i = 0; i < res.data.quantity; i++) {
              const temp = JSON.parse(
                JSON.stringify(defaultStateSingleProduct)
              );
              tempCopyDetails.push(i + 1);
              tempState.push(temp);
              tempPreviewImages.push(0);
            }
            console.log("Initial EDIT State:");
            console.log(tempState);
            setCopyDetails(tempCopyDetails);
            setEditState(tempState);
            setPreviewImages(tempPreviewImages);
          }
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const SAMPLE_IMAGE_ARRAY = [
    sample_1_1,
    sample_1_2,
    sample_2_1,
    sample_2_2,
    sample_3_1,
    sample_3_2,
    sample_4_1,
    sample_4_2,
  ];
  const verticalSampleArray = [sample_1_2, sample_2_2, sample_3_2, sample_4_2];
  const [showSampleThumbnail, setShowSampleThumbnail] = useState(false);
  const [showSampleImage, setShowSampleImage] = useState(sample_1_1);
  const back_pic = () => {
    for (let i = 0; i < SAMPLE_IMAGE_ARRAY.length; i++) {
      if (SAMPLE_IMAGE_ARRAY[i] === showSampleImage) {
        if (i === 0) {
          setShowSampleImage(SAMPLE_IMAGE_ARRAY[SAMPLE_IMAGE_ARRAY.length - 1]);
        } else {
          setShowSampleImage(SAMPLE_IMAGE_ARRAY[i - 1]);
        }
      }
    }
  };
  const next_pic = () => {
    for (let i = 0; i < SAMPLE_IMAGE_ARRAY.length; i++) {
      if (SAMPLE_IMAGE_ARRAY[i] === showSampleImage) {
        if (i === SAMPLE_IMAGE_ARRAY.length - 1) {
          setShowSampleImage(SAMPLE_IMAGE_ARRAY[0]);
        } else {
          setShowSampleImage(SAMPLE_IMAGE_ARRAY[i + 1]);
        }
      }
    }
  };
  const [showModal, setShowModal] = useState(false);
  const changeCopyDetails = (details, index) => {
    console.log("CHANGE COPY DETAILS");
    console.log(index);
    console.log(details);
    const newDetails = JSON.parse(JSON.stringify(copyDetails));
    newDetails[index] = details;
    setCopyDetails(newDetails);
    changeEditState(index, JSON.parse(JSON.stringify(editState[details - 1])));
  };
  return (
    <>
      {saveSuccess && (
        <div className={styles.SAVE_SUCCESS_MAIN}>
          <div className={styles.save_success_main_div}>
            <div className={styles.save_success_main_text}>
              一時保存しました
            </div>
            <ion-icon
              onClick={() => {
                setSaveSuccess(false);
              }}
              name="close"
            ></ion-icon>
          </div>
        </div>
      )}
      <Header />
      {showSelectionPopup && (
        <PhotoSelection
          skey={psk}
          count={imagesLeft}
          done={onPhotoSelectionEnd}
        />
      )}
      {!showSelectionPopup && (
        <div className={styles.wooden_square_edit_screen_main_div}>
          {count > 0 && (
            <div onClick={saveToServer} className={styles.save_box_main}>
              <img
                src={save_icon}
                className={styles.save_icon_image}
                alt="save"
              />
            </div>
          )}
          <DesignBoxNavigationCrumb active={3} />
          <EditScreenItemHeaderDiv
            title={"年賀状20枚"}
            subtitle={""}
            count={count}
            address={"会員様住所"}
            item={item}
          />
          <div className={styles.spacing01}></div>

          <EditScreenHeaderInfoDiv
            lines={["情報を入力し、写真を選択してください。"]}
          />
          <div className={styles.spacing02}></div>
          <div className={styles.hr01}></div>
          <div className={styles.sample_header01}>Sample</div>

          <div className={styles.sample_image_main_div}>
            {showSampleThumbnail && (
              <div className={styles.sample_preview}>
                <img
                  src={showSampleImage}
                  width={
                    verticalSampleArray.includes(showSampleImage) ? 500 : 738
                  }
                  height={
                    verticalSampleArray.includes(showSampleImage) ? 738 : 500
                  }
                  alt="sample_thumb"
                />
                <span
                  onClick={back_pic}
                  className={`${styles.arrow_icon_left} material-icons`}
                >
                  keyboard_arrow_left
                </span>
                <span
                  onClick={next_pic}
                  className={`${styles.arrow_icon_right} material-icons`}
                >
                  keyboard_arrow_right
                </span>
                <div
                  onClick={() => {
                    setShowSampleThumbnail(false);
                  }}
                  className={styles.cross_div}
                >
                  <ion-icon
                    className={styles.cross_icon}
                    name="close"
                  ></ion-icon>
                </div>
              </div>
            )}

            <div className={styles.sample_image_single_row}>
              <div
                onClick={() => {
                  setShowSampleImage(sample_1_1);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_horizontal_column}
              >
                <img
                  src={sample_1_1}
                  className={styles.horizontal_sample_image}
                  width={300}
                  height={202}
                  alt="sample_1_1"
                />
                <div className={styles.sample_image_bottom_text}>
                  Aタイプ・1枚（横）
                </div>
              </div>
              <div
                onClick={() => {
                  setShowSampleImage(sample_1_2);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_vertical_column}
              >
                <img
                  src={sample_1_2}
                  className={styles.vertical_sample_image}
                  width={202}
                  height={300}
                  alt="sample_1_2"
                />
                <div className={styles.sample_image_bottom_text}>
                  Aタイプ・1枚（縦）
                </div>
              </div>
            </div>
            <div className={styles.sample_hr}></div>
            <div className={styles.sample_image_single_row}>
              <div
                onClick={() => {
                  setShowSampleImage(sample_2_1);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_horizontal_column}
              >
                <img
                  src={sample_2_1}
                  className={styles.horizontal_sample_image}
                  width={300}
                  height={202}
                  alt="sample_2_1"
                />
                <div className={styles.sample_image_bottom_text}>
                  Aタイプ・4枚（縦）
                </div>
              </div>
              <div
                onClick={() => {
                  setShowSampleImage(sample_2_2);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_vertical_column}
              >
                <img
                  src={sample_2_2}
                  className={styles.vertical_sample_image}
                  width={202}
                  height={300}
                  alt="sample_2_2"
                />
                <div className={styles.sample_image_bottom_text}>
                  Aタイプ・4枚（縦）
                </div>
              </div>
            </div>
            <div className={styles.sample_hr}></div>
            <div className={styles.sample_image_single_row}>
              <div
                onClick={() => {
                  setShowSampleImage(sample_3_1);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_horizontal_column}
              >
                <img
                  src={sample_3_1}
                  className={styles.horizontal_sample_image}
                  style={{ border: 0 }}
                  width={300}
                  height={202}
                  alt="sample_3_1"
                />
                <div className={styles.sample_image_bottom_text}>
                  Bタイプ・1枚（横）
                </div>
              </div>
              <div
                onClick={() => {
                  setShowSampleImage(sample_3_2);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_vertical_column}
              >
                <img
                  src={sample_3_2}
                  className={styles.vertical_sample_image}
                  style={{ border: 0 }}
                  width={202}
                  height={300}
                  alt="sample_3_2"
                />
                <div className={styles.sample_image_bottom_text}>
                  Bタイプ・1枚（縦）
                </div>
              </div>
            </div>
            <div className={styles.sample_hr}></div>
            <div className={styles.sample_image_single_row}>
              <div
                onClick={() => {
                  setShowSampleImage(sample_4_1);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_horizontal_column}
              >
                <img
                  src={sample_4_1}
                  className={styles.horizontal_sample_image}
                  style={{ border: 0 }}
                  width={300}
                  height={202}
                  alt="sample_4_1"
                />
                <div className={styles.sample_image_bottom_text}>
                  Bタイプ・4枚（縦）
                </div>
              </div>
              <div
                onClick={() => {
                  setShowSampleImage(sample_4_2);
                  console.log(sample_4_2);
                  setShowSampleThumbnail(true);
                }}
                className={styles.sample_image_single_image_vertical_column}
              >
                <img
                  src={sample_4_2}
                  className={styles.vertical_sample_image}
                  style={{ border: 0 }}
                  width={202}
                  height={300}
                  alt="sample_4_2"
                />
                <div className={styles.sample_image_bottom_text}>
                  Bタイプ・4枚（縦）
                </div>
              </div>
            </div>
          </div>

          {[...Array(count)].map((_, index) => {
            const childRef = childRefs.current[index];
            return (
              <NewYearCardReusable
                key={index}
                ref={childRef}
                index={index}
                callback={changeEditState}
                callbackPreviewChange={changePreviewImage}
                state={editState[index]}
                image_selection_popup={imageSelectionPopup}
                //new stuff
                saveThisProduct={saveToServer}
                changeCopyDetails={changeCopyDetails}
                selectedCopyDetails={copyDetails[index]}
                currentPageNumber={index + 1}
                totalPageNumber={count}
                preview_copied_image={previewImages[index]}
                confirmEdits={confirmEdits}
              />
            );
          })}

          {showModal && (
            <div className={styles.incomplete_modal_main}>
              <div className={styles.modal_head01}>
                <div>
                  パターンと一致するために必要
                  <br />
                  な画像の数が正しく選択されていません。
                </div>
                <div>枚数を変更するか、</div>
                <div>写真を追加してください。</div>
              </div>
              <div className={styles.modal_head02}>追加写真選択</div>
              <div
                onClick={() => {
                  setShowModal(false);
                }}
                className={styles.modal_close}
              >
                <ion-icon
                  className={styles.modal_cross_icon}
                  name="close"
                ></ion-icon>
              </div>
            </div>
          )}
        </div>
      )}
      <Footer />
    </>
  );
};

export default NewYearCard;
